import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import SubjectsTable from './SubjectsTable'
import SubjectModal from './SubjectModal'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Add from '@material-ui/icons/Add'
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux'
import {
    addSubjects, 
    socialComunitiAction, 
    deleteSubject,
    clearSubject,
    editSubject,
    setSubjects,
    saveEditableSubject
} from '../../../redux/actions/socialComuniti.action'

const useStyles = makeStyles(theme => ({
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
      },
      button: {
        // marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
      },

  }));

const mapStateToProps = state => ({
    merchantName: state.socialCommunity.merchantName,
    agentSurname: state.socialCommunity.agentSurname,
    agentName: state.socialCommunity.agentName,
    agentPatronymic: state.socialCommunity.agentPatronymic,
    phone: state.socialCommunity.phone,
    email: state.socialCommunity.email,
    requestDetails: state.socialCommunity.requestDetails
})

export default connect(
    mapStateToProps, 
    {
        addSubjects, 
        socialComunitiAction, 
        deleteSubject,
        clearSubject,
        editSubject,
        setSubjects,
        saveEditableSubject
    })(function PaymentForm(props) {
    const {
        addSubjects, 
        socialComunitiAction, 
        merchantName,
        agentSurname,
        agentName,
        agentPatronymic,
        phone,
        email,
        requestDetails, 
        deleteSubject,
        clearSubject,
        editSubject,
        setSubjects,
        saveEditableSubject,
        handleNextTable,
        handleBack
    } = props;
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [tableIndex, setTableIndex] = React.useState('');

    const handleClickOpen = () => {
        setTableIndex('')
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setTableIndex('')
        clearSubject()
    };

    const addSubject = () => {
        const data = {
            merchantName,
            agentSurname,
            agentName,
            agentPatronymic,
            phone,
            email,
        }

        addSubjects(data);

        handleClose()
    }

    const handleChange = e => {
        socialComunitiAction(e.target.name, e.target.value)
    }

    const handleChangeCallback = React.useCallback((e) => {
        handleChange(e)
      }, [])

    const handleDelete = (index) => {
        setTableIndex(index)
        deleteSubject(index)
    }

    const handleEdit = (index) => {
        setTableIndex(index)
        const rows = [...requestDetails];
        editSubject(rows[index])

        setOpen(true);

    }

    const handleEditSubject = (e) => {
        
        const data = {
            merchantName,
            agentSurname,
            agentName,
            agentPatronymic,
            phone,
            email,
        }

        saveEditableSubject(data, tableIndex)
        handleClose()
    }


  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
      Суб'єкти, у яких буде застосовано МШ та контакти
      </Typography>
      <div className={classes.buttons}>
            <Button variant="contained" color="primary" className={classes.button} onClick={handleClickOpen}>
              <Add className={classes.extendedIcon}/>
              Додати
            </Button>
            <SubjectModal 
                open={open} 
                onClose={handleClose} 
                addSubject={addSubject}
                handleEditSubject={handleEditSubject}
                handleChange={handleChangeCallback} 
                merchantName={merchantName}
                agentSurname={agentSurname}
                agentName={agentName}
                agentPatronymic={agentPatronymic}
                phone={phone}
                email={email}
                tableIndex={tableIndex}
            />
      </div>
      <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
              <SubjectsTable requestDetails={requestDetails} handleDelete={handleDelete} handleEdit={handleEdit}/>
          </Grid>
          <Grid item xs={12} md={12}>
          <div className={classes.buttons}>
          <Button variant="contained" color="primary" onClick={handleBack}>Назад</Button>
          <Button variant="contained" color="primary" className={classes.button} onClick={handleNextTable} disabled={requestDetails.length === 0}>Далі</Button>
          </div>
          </Grid>
      </Grid>
    </React.Fragment>
  );
})
